import { render, staticRenderFns } from "./houseRentdeclaration.vue?vue&type=template&id=3da6beee"
import script from "./houseRentdeclaration.vue?vue&type=script&lang=js"
export * from "./houseRentdeclaration.vue?vue&type=script&lang=js"
import style0 from "./houseRentdeclaration.vue?vue&type=style&index=0&id=3da6beee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports